import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initGA4 } from "./utils/ga4";

// react-snap loads the app in a headless browser at build time with this UA.
// Skip client-only side effects (analytics, tracking) during prerendering so
// they don't pollute the static HTML or fire fake pageviews.
const isPrerendering = navigator.userAgent === "ReactSnap";

if (!isPrerendering) {
  // GA4'ü başlat (bedava çapraz kontrol kaynağı — kendi analytics'imize ek)
  initGA4();
}

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Blog pages are prerendered with markup that closely matches React's output,
// so hydrate them (no flash). The homepage snapshot (and the empty SPA shell)
// is a curated crawler-only subset that won't match, so render fresh with
// createRoot, which cleanly discards it — avoids hydration mismatch errors.
const path = window.location.pathname;
const isBlogRoute = path === "/blog" || path.startsWith("/blog/");

if (rootElement.hasChildNodes() && isBlogRoute) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
